<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><em>Contents</em></h1>
<p class="toc-fm"><em><a href="#/006_Preface#fm-1">Preface</a></em></p>
<p class="toc-fm"><em><a href="#/007_Abbrevation#fm-2">List of Abbreviations</a></em></p>
<p class="toc-chap"><a href="#/008_Chapter01#ch-1">1.<span class="toc">Introducing Narrative</span></a></p>
<p class="toc-chap"><span href="#/009_Chapter02#ch-2" title="Link target outside of Sample">2.<span class="toc">The Grammar of Narration</span></span></p>
<p class="toc-chap"><span href="#/010_Chapter03#ch-3" title="Link target outside of Sample">3.<span class="toc">Stories in Context</span></span></p>
<p class="toc-chap"><span href="#/011_Chapter04#ch-4" title="Link target outside of Sample">4.<span class="toc">Fragments of Implicit Protonarratives</span></span></p>
<p class="toc-chap"><span href="#/012_Chapter05#ch-5" title="Link target outside of Sample">5.<span class="toc">Of Narrative Substructures and Worldview Narratives</span></span></p>
<p class="toc-bm"><span href="#/013_Bibliography#bm-1" title="Link target outside of Sample"><em>Bibliography</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?4c401636